import { hasAnyRoleUtil } from "../services/roleService";

export const SUPPLIERS_MODULE_ADMIN = "SUPPLIERS_MODULE_ADMIN";
export const SERALOGIN_SUPPLIERS_ACCESS = "SERALOGIN_SUPPLIERS_ACCESS";
export const SUPPLIERS_NATIONAL_ADMIN = "SUPPLIERS_NATIONAL_ADMIN";
export const SUPPLIERS_INTERNATIONAL_ADMIN = "SUPPLIERS_INTERNATIONAL_ADMIN";
export const SUPPLIERS_SERVICE_ADMIN = "SUPPLIERS_SERVICE_ADMIN";

export const canManageSuppliersModule = (roleList = []) =>
  hasAnyRoleUtil([SUPPLIERS_MODULE_ADMIN], roleList);

export const canManageNationalSuppliers = (roleList = []) =>
  hasAnyRoleUtil([SUPPLIERS_MODULE_ADMIN, SUPPLIERS_NATIONAL_ADMIN], roleList);

export const canManageInternationalSuppliers = (roleList = []) =>
  hasAnyRoleUtil(
    [SUPPLIERS_MODULE_ADMIN, SUPPLIERS_INTERNATIONAL_ADMIN],
    roleList
  );

export const canManageServiceSuppliers = (roleList = []) =>
  hasAnyRoleUtil([SUPPLIERS_MODULE_ADMIN, SUPPLIERS_SERVICE_ADMIN], roleList);
